import axios from 'axios';

const apiService = axios.create({
  baseURL: 'https://mimos.pos-fenix.com/',
  // baseURL: 'http://localhost:4000/',
  timeout: 12000000,
});

export default apiService;
